import { render, staticRenderFns } from "./FileUploadItem.vue?vue&type=template&id=5aba5d15&scoped=true&"
import script from "./FileUploadItem.vue?vue&type=script&lang=js&"
export * from "./FileUploadItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aba5d15",
  null
  
)

export default component.exports